import { Brand } from '../../models/brand';

export const mockBrands: Brand[] = [
  {
    id: 1,
    name: 'A. Lange & Söhne',
    imageUrl: 'brands/a-langue-sohne.png',
    description: 'Relojes de lujo alemanes.',
    isActive: true,
  },
  {
    id: 2,
    name: 'ABP Paris',
    imageUrl: 'https://example.com/abp-paris.png',
    description: 'Diseños modernos y elegantes.',
    isActive: false,
  },
  {
    id: 3,
    name: 'Accutron',
    imageUrl: 'https://example.com/accutron.png',
    description: 'Conocidos por su tecnología de diapasón.',
    isActive: true,
  },
  {
    id: 4,
    name: 'Aerowatch',
    imageUrl: 'https://example.com/aerowatch.png',
    description: 'Relojes suizos con estilo clásico.',
    isActive: false,
  },
  {
    id: 5,
    name: 'Aigle',
    imageUrl: 'https://example.com/aigle.png',
    description: 'Relojes deportivos y resistentes.',
    isActive: true,
  },
  {
    id: 6,
    name: 'Aigner',
    imageUrl: 'https://example.com/aigner.png',
    description: 'Elegancia y sofisticación.',
    isActive: false,
  },
  {
    id: 7,
    name: 'Alain Silberstein',
    imageUrl: 'https://example.com/alain-silberstein.png',
    description: 'Diseños vanguardistas y coloridos.',
    isActive: true,
  },
  {
    id: 8,
    name: 'Alexander Shorokhoff',
    imageUrl: 'https://example.com/alexander-shorokhoff.png',
    description: 'Arte y relojería combinados.',
    isActive: false,
  },
  {
    id: 9,
    name: 'Alfred Dunhill',
    imageUrl: 'https://example.com/alfred-dunhill.png',
    description: 'Lujo británico.',
    isActive: true,
  },
  {
    id: 10,
    name: 'Alfred Rochat & Fils',
    imageUrl: 'https://example.com/alfred-rochat-fils.png',
    description: 'Relojería tradicional suiza.',
    isActive: false,
  },
  {
    id: 11,
    name: 'Alpina',
    imageUrl: 'https://example.com/alpina.png',
    description: 'Relojes deportivos de alta gama.',
    isActive: true,
  },
  {
    id: 12,
    name: 'Andersen Genève',
    imageUrl: 'https://example.com/andersen-geneve.png',
    description: 'Relojes exclusivos y personalizados.',
    isActive: false,
  },
  {
    id: 13,
    name: 'Andreas Strehler',
    imageUrl: 'https://example.com/andreas-strehler.png',
    description: 'Innovación y precisión.',
    isActive: true,
  },
  {
    id: 14,
    name: 'Angelus',
    imageUrl: 'https://example.com/angelus.png',
    description: 'Relojes complicados y únicos.',
    isActive: false,
  },
  {
    id: 15,
    name: 'Angular Momentum',
    imageUrl: 'https://example.com/angular-momentum.png',
    description: 'Diseños artesanales.',
    isActive: true,
  },
  {
    id: 16,
    name: 'Anonimo',
    imageUrl: 'https://example.com/anonimo.png',
    description: 'Relojes robustos y elegantes.',
    isActive: false,
  },
  {
    id: 17,
    name: 'Apple',
    imageUrl: 'https://example.com/apple.png',
    description: 'Tecnología y diseño innovador.',
    isActive: true,
  },
  {
    id: 18,
    name: 'Aquanautic',
    imageUrl: 'https://example.com/aquanautic.png',
    description: 'Relojes náuticos.',
    isActive: false,
  },
  {
    id: 19,
    name: 'Aquastar',
    imageUrl: 'https://example.com/aquastar.png',
    description: 'Relojes de buceo profesionales.',
    isActive: true,
  },
  {
    id: 20,
    name: 'Aristo',
    imageUrl: 'https://example.com/aristo.png',
    description: 'Relojes alemanes de alta calidad.',
    isActive: false,
  },
  {
    id: 21,
    name: 'Armand Nicolet',
    imageUrl: 'https://example.com/armand-nicolet.png',
    description: 'Relojería suiza tradicional.',
    isActive: true,
  },
  {
    id: 22,
    name: 'Armani',
    imageUrl: 'https://example.com/armani.png',
    description: 'Estilo y moda italiana.',
    isActive: false,
  },
  {
    id: 23,
    name: 'Armin Strom',
    imageUrl: 'https://example.com/armin-strom.png',
    description: 'Relojes de manufactura suiza.',
    isActive: true,
  },
  {
    id: 24,
    name: 'Arnold & Son',
    imageUrl: 'https://example.com/arnold-son.png',
    description: 'Relojes de alta precisión.',
    isActive: false,
  },
  {
    id: 25,
    name: 'Artisanal',
    imageUrl: 'https://example.com/artisanal.png',
    description: 'Diseños únicos y artesanales.',
    isActive: true,
  },
  {
    id: 26,
    name: 'Artya',
    imageUrl: 'https://example.com/artya.png',
    description: 'Arte y relojería.',
    isActive: false,
  },
  {
    id: 27,
    name: 'Askania',
    imageUrl: 'https://example.com/askania.png',
    description: 'Relojes alemanes con historia.',
    isActive: true,
  },
  {
    id: 28,
    name: 'Ateliers deMonaco',
    imageUrl: 'https://example.com/ateliers-demonaco.png',
    description: 'Relojes de lujo monegascos.',
    isActive: false,
  },
  {
    id: 29,
    name: 'Atlantic',
    imageUrl: 'https://example.com/atlantic.png',
    description: 'Relojes suizos accesibles.',
    isActive: true,
  },
  {
    id: 30,
    name: 'Audemars Piguet',
    imageUrl: 'brands/audemars-piguet.png',
    description: 'Famosos por el Royal Oak.',
    isActive: false,
  },
  {
    id: 31,
    name: 'Auguste Reymond',
    imageUrl: 'https://example.com/auguste-reymond.png',
    description: 'Relojes suizos clásicos.',
    isActive: true,
  },
  {
    id: 32,
    name: 'Auricoste',
    imageUrl: 'https://example.com/auricoste.png',
    description: 'Relojes de aviación.',
    isActive: false,
  },
  {
    id: 33,
    name: 'Avier',
    imageUrl: 'https://example.com/avier.png',
    description: 'Diseños modernos y funcionales.',
    isActive: true,
  },
  {
    id: 34,
    name: 'Azimuth',
    imageUrl: 'https://example.com/azimuth.png',
    description: 'Relojes futuristas.',
    isActive: false,
  },
  {
    id: 35,
    name: 'Azzaro',
    imageUrl: 'https://example.com/azzaro.png',
    description: 'Elegancia y estilo.',
    isActive: true,
  },
  {
    id: 36,
    name: 'B.R.M',
    imageUrl: 'https://example.com/brm.png',
    description: 'Relojes inspirados en el automovilismo.',
    isActive: false,
  },
  {
    id: 37,
    name: 'Ball',
    imageUrl: 'https://example.com/ball.png',
    description: 'Relojes resistentes y precisos.',
    isActive: true,
  },
  {
    id: 38,
    name: 'Balmain',
    imageUrl: 'https://example.com/balmain.png',
    description: 'Moda y lujo.',
    isActive: false,
  },
  {
    id: 39,
    name: 'Baltic',
    imageUrl: 'https://example.com/baltic.png',
    description: 'Diseños retro modernos.',
    isActive: true,
  },
  {
    id: 40,
    name: 'Barington',
    imageUrl: 'https://example.com/barington.png',
    description: 'Relojes elegantes y accesibles.',
    isActive: false,
  },
  {
    id: 41,
    name: 'Baume & Mercier',
    imageUrl: 'https://example.com/baume-mercier.png',
    description: 'Relojes suizos de lujo.',
    isActive: true,
  },
  {
    id: 42,
    name: 'Bedat & Co',
    imageUrl: 'https://example.com/bedat-co.png',
    description: 'Diseños minimalistas.',
    isActive: false,
  },
  {
    id: 43,
    name: 'Behrens',
    imageUrl: 'https://example.com/behrens.png',
    description: 'Innovación en diseño.',
    isActive: true,
  },
  {
    id: 44,
    name: 'Bell & Ross',
    imageUrl: 'brands/bell-ross.png',
    description: 'Relojes inspirados en la aviación.',
    isActive: false,
  },
  {
    id: 45,
    name: 'Benrus',
    imageUrl: 'https://example.com/benrus.png',
    description: 'Relojes clásicos americanos.',
    isActive: true,
  },
  {
    id: 46,
    name: 'Benzinger',
    imageUrl: 'https://example.com/benzinger.png',
    description: 'Relojes artesanales.',
    isActive: false,
  },
  {
    id: 47,
    name: 'Berne',
    imageUrl: 'https://example.com/berne.png',
    description: 'Relojes resistentes y funcionales.',
    isActive: true,
  },
  {
    id: 48,
    name: 'Bertolucci',
    imageUrl: 'https://example.com/bertolucci.png',
    description: 'Diseños italianos elegantes.',
    isActive: false,
  },
  {
    id: 49,
    name: 'Beuchat',
    imageUrl: 'https://example.com/beuchat.png',
    description: 'Relojes de buceo profesionales.',
    isActive: true,
  },
  {
    id: 50,
    name: 'Bifora',
    imageUrl: 'https://example.com/bifora.png',
    description: 'Relojes clásicos alemanes.',
    isActive: false,
  },
  {
    id: 51,
    name: 'Black-Out Concept',
    imageUrl: 'https://example.com/black-out-concept.png',
    description: 'Diseños oscuros y misteriosos.',
    isActive: true,
  },
  {
    id: 52,
    name: 'Blacksand',
    imageUrl: 'https://example.com/blacksand.png',
    description: 'Relojes minimalistas.',
    isActive: false,
  },
  {
    id: 53,
    name: 'Blancier',
    imageUrl: 'https://example.com/blancier.png',
    description: 'Relojes suizos de alta gama.',
    isActive: true,
  },
  {
    id: 54,
    name: 'Blancpain',
    imageUrl: 'brands/blancpain.png',
    description: 'Una de las marcas más antiguas.',
    isActive: false,
  },
  {
    id: 55,
    name: 'blu',
    imageUrl: 'https://example.com/blu.png',
    description: 'Diseños modernos y coloridos.',
    isActive: true,
  },
  {
    id: 56,
    name: 'Boegli',
    imageUrl: 'https://example.com/boegli.png',
    description: 'Relojes suizos de lujo.',
    isActive: false,
  },
  {
    id: 57,
    name: 'Bogner Time',
    imageUrl: 'https://example.com/bogner-time.png',
    description: 'Relojes deportivos.',
    isActive: true,
  },
  {
    id: 58,
    name: 'Boldr',
    imageUrl: 'https://example.com/boldr.png',
    description: 'Relojes robustos y aventureros.',
    isActive: false,
  },
  {
    id: 59,
    name: 'Bomberg',
    imageUrl: 'https://example.com/bomberg.png',
    description: 'Diseños atrevidos y únicos.',
    isActive: true,
  },
  {
    id: 60,
    name: 'Borgeaud',
    imageUrl: 'https://example.com/borgeaud.png',
    description: 'Relojes suizos clásicos.',
    isActive: false,
  },
  {
    id: 61,
    name: 'Boucheron',
    imageUrl: 'https://example.com/boucheron.png',
    description: 'Lujo y joyería.',
    isActive: true,
  },
  {
    id: 62,
    name: 'Bovet',
    imageUrl: 'https://example.com/bovet.png',
    description: 'Relojes de alta relojería.',
    isActive: false,
  },
  {
    id: 63,
    name: 'Breguet',
    imageUrl: 'https://example.com/breguet.png',
    description: 'Innovación y tradición.',
    isActive: true,
  },
  {
    id: 64,
    name: 'Breil',
    imageUrl: 'https://example.com/breil.png',
    description: 'Diseños italianos modernos.',
    isActive: false,
  },
  {
    id: 65,
    name: 'Breitling',
    imageUrl: 'brands/breitling.png',
    description: 'Especializados en relojes de aviación.',
    isActive: true,
  },
  {
    id: 66,
    name: 'Bremont',
    imageUrl: 'https://example.com/bremont.png',
    description: 'Relojes británicos de alta gama.',
    isActive: false,
  },
  {
    id: 67,
    name: 'Brior',
    imageUrl: 'https://example.com/brior.png',
    description: 'Diseños únicos y artesanales.',
    isActive: true,
  },
  {
    id: 68,
    name: 'Bruno Söhnle',
    imageUrl: 'https://example.com/bruno-sohnle.png',
    description: 'Relojes alemanes modernos.',
    isActive: false,
  },
  {
    id: 69,
    name: 'Bulgari',
    imageUrl: 'https://example.com/bulgari.png',
    description: 'Lujo y diseño italiano.',
    isActive: true,
  },
  {
    id: 70,
    name: 'Bulova',
    imageUrl: 'https://example.com/bulova.png',
    description: 'Innovación y precisión.',
    isActive: false,
  },
  {
    id: 71,
    name: 'Bunz',
    imageUrl: 'https://example.com/bunz.png',
    description: 'Relojes suizos de lujo.',
    isActive: true,
  },
  {
    id: 72,
    name: 'Burberry',
    imageUrl: 'https://example.com/burberry.png',
    description: 'Moda británica.',
    isActive: false,
  },
  {
    id: 73,
    name: 'BWC-Swiss',
    imageUrl: 'https://example.com/bwc-swiss.png',
    description: 'Relojes suizos de alta calidad.',
    isActive: true,
  },
  {
    id: 74,
    name: 'C.H. Wolf',
    imageUrl: 'https://example.com/ch-wolf.png',
    description: 'Relojes alemanes clásicos.',
    isActive: false,
  },
  {
    id: 75,
    name: 'Cabestan',
    imageUrl: 'https://example.com/cabestan.png',
    description: 'Diseños únicos y complicados.',
    isActive: true,
  },
  {
    id: 76,
    name: 'Cadet Chronostar',
    imageUrl: 'https://example.com/cadet-chronostar.png',
    description: 'Relojes deportivos.',
    isActive: false,
  },
  {
    id: 77,
    name: 'Camel Active',
    imageUrl: 'https://example.com/camel-active.png',
    description: 'Estilo urbano y moderno.',
    isActive: true,
  },
  {
    id: 78,
    name: 'Camille Fournet',
    imageUrl: 'https://example.com/camille-fournet.png',
    description: 'Relojes de lujo.',
    isActive: false,
  },
  {
    id: 79,
    name: 'Candino',
    imageUrl: 'https://example.com/candino.png',
    description: 'Relojes suizos accesibles.',
    isActive: true,
  },
  {
    id: 80,
    name: 'Carl F. Bucherer',
    imageUrl: 'https://example.com/carl-f-bucherer.png',
    description: 'Relojes suizos de alta gama.',
    isActive: false,
  },
  {
    id: 81,
    name: 'Carlo Ferrara',
    imageUrl: 'https://example.com/carlo-ferrara.png',
    description: 'Diseños italianos elegantes.',
    isActive: true,
  },
  {
    id: 82,
    name: 'Carlo Maroni',
    imageUrl: 'https://example.com/carlo-maroni.png',
    description: 'Relojes artesanales.',
    isActive: false,
  },
  {
    id: 83,
    name: 'Cartier',
    imageUrl: 'brands/cartier.png',
    description: 'Lujo y elegancia.',
    isActive: true,
  },
  {
    id: 84,
    name: 'Casio',
    imageUrl: 'https://example.com/casio.png',
    description: 'Relojes resistentes y asequibles.',
    isActive: false,
  },
  {
    id: 85,
    name: 'Catamaran',
    imageUrl: 'https://example.com/catamaran.png',
    description: 'Relojes náuticos.',
    isActive: true,
  },
  {
    id: 86,
    name: 'Catena',
    imageUrl: 'https://example.com/catena.png',
    description: 'Relojes suizos de alta calidad.',
    isActive: false,
  },
  {
    id: 87,
    name: 'Catorex',
    imageUrl: 'https://example.com/catorex.png',
    description: 'Relojes suizos clásicos.',
    isActive: true,
  },
  {
    id: 88,
    name: 'Cattin',
    imageUrl: 'https://example.com/cattin.png',
    description: 'Relojes artesanales.',
    isActive: false,
  },
  {
    id: 89,
    name: 'Century',
    imageUrl: 'https://example.com/century.png',
    description: 'Relojes de lujo.',
    isActive: true,
  },
  {
    id: 90,
    name: 'Cerruti',
    imageUrl: 'https://example.com/cerruti.png',
    description: 'Estilo y moda.',
    isActive: false,
  },
  {
    id: 91,
    name: 'Certina',
    imageUrl: 'https://example.com/certina.png',
    description: 'Relojes deportivos suizos.',
    isActive: true,
  },
  {
    id: 92,
    name: 'Chanel',
    imageUrl: 'https://example.com/chanel.png',
    description: 'Lujo y moda.',
    isActive: false,
  },
  {
    id: 93,
    name: 'Charmex',
    imageUrl: 'https://example.com/charmex.png',
    description: 'Relojes suizos modernos.',
    isActive: true,
  },
  {
    id: 94,
    name: 'Charriol',
    imageUrl: 'https://example.com/charriol.png',
    description: 'Diseños elegantes.',
    isActive: false,
  },
  {
    id: 95,
    name: 'Chase-Durer',
    imageUrl: 'https://example.com/chase-durer.png',
    description: 'Relojes de lujo.',
    isActive: true,
  },
  {
    id: 96,
    name: 'Chaumet',
    imageUrl: 'https://example.com/chaumet.png',
    description: 'Lujo y joyería.',
    isActive: false,
  },
  {
    id: 97,
    name: 'Chopard',
    imageUrl: 'brands/chopard.png',
    description: 'Relojes de alta relojería.',
    isActive: true,
  },
  {
    id: 98,
    name: 'Chris Benz',
    imageUrl: 'https://example.com/chris-benz.png',
    description: 'Diseños modernos.',
    isActive: false,
  },
  {
    id: 99,
    name: 'Christiaan v.d. Klaauw',
    imageUrl: 'https://example.com/christiaan-vdklaauw.png',
    description: 'Relojes astronómicos.',
    isActive: true,
  },
  {
    id: 100,
    name: 'Christofle',
    imageUrl: 'https://example.com/christofle.png',
    description: 'Lujo y elegancia.',
    isActive: false,
  },
  {
    id: 101,
    name: 'Christophe Claret',
    imageUrl: 'https://example.com/christophe-claret.png',
    description: 'Relojes complicados.',
    isActive: true,
  },
  {
    id: 102,
    name: 'Christopher Ward',
    imageUrl: 'https://example.com/christopher-ward.png',
    description: 'Relojes británicos de alta calidad.',
    isActive: false,
  },
  {
    id: 103,
    name: 'Chronographe Suisse Cie',
    imageUrl: 'https://example.com/chronographe-suisse.png',
    description: 'Relojes suizos clásicos.',
    isActive: true,
  },
  {
    id: 104,
    name: 'Chronoswiss',
    imageUrl: 'brands/chronoswiss.png',
    description: 'Relojes de alta relojería.',
    isActive: false,
  },
  {
    id: 105,
    name: 'Churpfälzische Uhrenmanufaktur',
    imageUrl: 'https://example.com/churpfalzische.png',
    description: 'Relojes alemanes artesanales.',
    isActive: true,
  },
  {
    id: 106,
    name: 'Citizen',
    imageUrl: 'https://example.com/citizen.png',
    description: 'Conocidos por su tecnología Eco-Drive.',
    isActive: false,
  },
  {
    id: 107,
    name: 'ck Calvin Klein',
    imageUrl: 'https://example.com/ck-calvin-klein.png',
    description: 'Estilo moderno y minimalista.',
    isActive: true,
  },
  {
    id: 108,
    name: 'Claude Bernard',
    imageUrl: 'https://example.com/claude-bernard.png',
    description: 'Relojes suizos accesibles.',
    isActive: false,
  },
  {
    id: 109,
    name: 'Claude Meylan',
    imageUrl: 'https://example.com/claude-meylan.png',
    description: 'Relojes artesanales.',
    isActive: true,
  },
  {
    id: 110,
    name: 'Clerc',
    imageUrl: 'https://example.com/clerc.png',
    description: 'Relojes de buceo profesionales.',
    isActive: false,
  },
  {
    id: 111,
    name: 'Concord',
    imageUrl: 'https://example.com/concord.png',
    description: 'Relojes de lujo.',
    isActive: true,
  },
  {
    id: 112,
    name: 'Condor',
    imageUrl: 'https://example.com/condor.png',
    description: 'Relojes resistentes.',
    isActive: false,
  },
  {
    id: 113,
    name: 'Cornehl',
    imageUrl: 'https://example.com/cornehl.png',
    description: 'Relojes alemanes modernos.',
    isActive: true,
  },
  {
    id: 114,
    name: 'Cornelius & Cie',
    imageUrl: 'https://example.com/cornelius-cie.png',
    description: 'Relojes artesanales.',
    isActive: false,
  },
  {
    id: 115,
    name: 'Cortébert',
    imageUrl: 'https://example.com/cortebert.png',
    description: 'Relojes suizos clásicos.',
    isActive: true,
  },
  {
    id: 116,
    name: 'Corum',
    imageUrl: 'https://example.com/corum.png',
    description: 'Relojes de alta relojería.',
    isActive: false,
  },
  {
    id: 117,
    name: 'Creo',
    imageUrl: 'https://example.com/creo.png',
    description: 'Diseños modernos.',
    isActive: true,
  },
  {
    id: 118,
    name: 'Crockett & Jones',
    imageUrl: 'https://example.com/crockett-jones.png',
    description: 'Relojes británicos de lujo.',
    isActive: false,
  },
  {
    id: 119,
    name: 'Cronus',
    imageUrl: 'https://example.com/cronus.png',
    description: 'Relojes suizos modernos.',
    isActive: true,
  },
  {
    id: 120,
    name: 'Cuervo y Sobrinos',
    imageUrl: 'https://example.com/cuervo-y-sobrinos.png',
    description: 'Relojes de lujo cubanos.',
    isActive: false,
  },
  {
    id: 121,
    name: 'Cvstos',
    imageUrl: 'https://example.com/cvstos.png',
    description: 'Relojes de alta gama.',
    isActive: true,
  },
  {
    id: 122,
    name: 'CWC',
    imageUrl: 'https://example.com/cwc.png',
    description: 'Relojes militares.',
    isActive: false,
  },
  {
    id: 123,
    name: 'Cyclos',
    imageUrl: 'https://example.com/cyclos.png',
    description: 'Relojes deportivos.',
    isActive: true,
  },
  {
    id: 124,
    name: 'Cyma',
    imageUrl: 'https://example.com/cyma.png',
    description: 'Relojes suizos clásicos.',
    isActive: false,
  },
  {
    id: 125,
    name: 'Cyrus',
    imageUrl: 'https://example.com/cyrus.png',
    description: 'Relojes de alta relojería.',
    isActive: true,
  },
  {
    id: 126,
    name: 'Czapek',
    imageUrl: 'https://example.com/czapek.png',
    description: 'Relojes históricos.',
    isActive: false,
  },
  {
    id: 127,
    name: 'D.Dornblüth & Sohn',
    imageUrl: 'https://example.com/d-dornbluth-sohn.png',
    description: 'Relojes alemanes artesanales.',
    isActive: true,
  },
  {
    id: 128,
    name: 'Damasko',
    imageUrl: 'https://example.com/damasko.png',
    description: 'Relojes resistentes.',
    isActive: false,
  },
  {
    id: 129,
    name: 'Daniel Roth',
    imageUrl: 'https://example.com/daniel-roth.png',
    description: 'Relojes de alta relojería.',
    isActive: true,
  },
  {
    id: 130,
    name: 'Dark Rush',
    imageUrl: 'https://example.com/dark-rush.png',
    description: 'Diseños oscuros y modernos.',
    isActive: false,
  },
  {
    id: 131,
    name: 'Davidoff',
    imageUrl: 'https://example.com/davidoff.png',
    description: 'Lujo y estilo.',
    isActive: true,
  },
  {
    id: 132,
    name: 'Davosa',
    imageUrl: 'https://example.com/davosa.png',
    description: 'Relojes suizos de alta calidad.',
    isActive: false,
  },
  {
    id: 133,
    name: 'De Bethune',
    imageUrl: 'https://example.com/de-bethune.png',
    description: 'Innovación en relojería.',
    isActive: true,
  },
  {
    id: 134,
    name: 'Decade',
    imageUrl: 'https://example.com/decade.png',
    description: 'Relojes modernos.',
    isActive: false,
  },
  {
    id: 135,
    name: 'Deep Blue',
    imageUrl: 'https://example.com/deep-blue.png',
    description: 'Relojes de buceo.',
    isActive: true,
  },
  {
    id: 136,
    name: 'De Grisogono',
    imageUrl: 'https://example.com/de-grisogono.png',
    description: 'Lujo y joyería.',
    isActive: false,
  },
  {
    id: 137,
    name: 'DeLaCour',
    imageUrl: 'https://example.com/delacour.png',
    description: 'Relojes de lujo.',
    isActive: true,
  },
  {
    id: 138,
    name: 'DeLaneau',
    imageUrl: 'https://example.com/delaneau.png',
    description: 'Relojes artesanales.',
    isActive: false,
  },
  {
    id: 139,
    name: 'Delma',
    imageUrl: 'https://example.com/delma.png',
    description: 'Relojes suizos de alta calidad.',
    isActive: true,
  },
  {
    id: 140,
    name: 'Devon',
    imageUrl: 'https://example.com/devon.png',
    description: 'Diseños futuristas.',
    isActive: false,
  },
  {
    id: 141,
    name: 'Dewitt',
    imageUrl: 'https://example.com/dewitt.png',
    description: 'Relojes de alta relojería.',
    isActive: true,
  },
  {
    id: 142,
    name: 'Diesel',
    imageUrl: 'https://example.com/diesel.png',
    description: 'Estilo urbano.',
    isActive: false,
  },
  {
    id: 143,
    name: 'Dietrich',
    imageUrl: 'https://example.com/dietrich.png',
    description: 'Diseños modernos.',
    isActive: true,
  },
  {
    id: 144,
    name: 'Dior',
    imageUrl: 'https://example.com/dior.png',
    description: 'Lujo y moda.',
    isActive: false,
  },
  {
    id: 145,
    name: 'Dodane',
    imageUrl: 'https://example.com/dodane.png',
    description: 'Relojes de aviación.',
    isActive: true,
  },
  {
    id: 146,
    name: 'Dolce & Gabbana',
    imageUrl: 'https://example.com/dolce-gabbana.png',
    description: 'Moda y lujo.',
    isActive: false,
  },
  {
    id: 147,
    name: 'Dom Baiz International',
    imageUrl: 'https://example.com/dom-baiz.png',
    description: 'Relojes de lujo.',
    isActive: true,
  },
  {
    id: 148,
    name: 'Doxa',
    imageUrl: 'https://example.com/doxa.png',
    description: 'Relojes de buceo.',
    isActive: false,
  },
  {
    id: 149,
    name: 'Dubey & Schaldenbrand',
    imageUrl: 'https://example.com/dubey-schaldenbrand.png',
    description: 'Relojes clásicos.',
    isActive: true,
  },
  {
    id: 150,
    name: 'DuBois 1785',
    imageUrl: 'https://example.com/dubois-1785.png',
    description: 'Relojes suizos de alta gama.',
    isActive: false,
  },
  {
    id: 151,
    name: 'DuBois et fils',
    imageUrl: 'https://example.com/dubois-et-fils.png',
    description: 'Relojes artesanales.',
    isActive: true,
  },
  {
    id: 152,
    name: 'Dufeau',
    imageUrl: 'https://example.com/dufeau.png',
    description: 'Relojes clásicos.',
    isActive: false,
  },
  {
    id: 153,
    name: 'Dugena',
    imageUrl: 'https://example.com/dugena.png',
    description: 'Relojes alemanes.',
    isActive: true,
  },
  {
    id: 154,
    name: 'Dürmeister',
    imageUrl: 'https://example.com/durmeister.png',
    description: 'Relojes alemanes modernos.',
    isActive: false,
  },
  {
    id: 155,
    name: 'Ebel',
    imageUrl: 'https://example.com/ebel.png',
    description: 'Relojes de lujo.',
    isActive: true,
  },
  {
    id: 156,
    name: 'Eberhard & Co.',
    imageUrl: 'https://example.com/eberhard.png',
    description: 'Relojes suizos clásicos.',
    isActive: false,
  },
  {
    id: 157,
    name: 'Edox',
    imageUrl: 'https://example.com/edox.png',
    description: 'Relojes deportivos.',
    isActive: true,
  },
  {
    id: 158,
    name: 'Egotempo',
    imageUrl: 'https://example.com/egotempo.png',
    description: 'Diseños modernos.',
    isActive: false,
  },
  {
    id: 159,
    name: 'Eichmüller',
    imageUrl: 'https://example.com/eichmuller.png',
    description: 'Relojes alemanes.',
    isActive: true,
  },
  {
    id: 160,
    name: 'El Charro',
    imageUrl: 'https://example.com/el-charro.png',
    description: 'Relojes artesanales.',
    isActive: false,
  },
  {
    id: 161,
    name: 'Election',
    imageUrl: 'https://example.com/election.png',
    description: 'Relojes modernos.',
    isActive: true,
  },
  {
    id: 162,
    name: 'Elgin',
    imageUrl: 'https://example.com/elgin.png',
    description: 'Relojes clásicos americanos.',
    isActive: false,
  },
  {
    id: 163,
    name: 'Elysee',
    imageUrl: 'https://example.com/elysee.png',
    description: 'Relojes alemanes.',
    isActive: true,
  },
  {
    id: 164,
    name: 'Engelhardt',
    imageUrl: 'https://example.com/engelhardt.png',
    description: 'Relojes alemanes.',
    isActive: false,
  },
  {
    id: 165,
    name: 'Enicar',
    imageUrl: 'https://example.com/enicar.png',
    description: 'Relojes suizos clásicos.',
    isActive: true,
  },
  {
    id: 166,
    name: 'Ennebi',
    imageUrl: 'https://example.com/ennebi.png',
    description: 'Relojes de buceo.',
    isActive: false,
  },
  {
    id: 167,
    name: 'Epos',
    imageUrl: 'https://example.com/epos.png',
    description: 'Relojes suizos modernos.',
    isActive: true,
  },
  {
    id: 168,
    name: 'Ernest Borel',
    imageUrl: 'https://example.com/ernest-borel.png',
    description: 'Relojes suizos clásicos.',
    isActive: false,
  },
  {
    id: 169,
    name: 'Ernst Benz',
    imageUrl: 'https://example.com/ernst-benz.png',
    description: 'Relojes de alta gama.',
    isActive: true,
  },
  {
    id: 170,
    name: 'Erwin Sattler',
    imageUrl: 'https://example.com/erwin-sattler.png',
    description: 'Relojes alemanes de lujo.',
    isActive: false,
  },
  {
    id: 171,
    name: 'Esprit',
    imageUrl: 'https://example.com/esprit.png',
    description: 'Estilo moderno.',
    isActive: true,
  },
  {
    id: 172,
    name: 'Eterna',
    imageUrl: 'https://example.com/eterna.png',
    description: 'Relojes suizos clásicos.',
    isActive: false,
  },
  {
    id: 173,
    name: 'Eulit',
    imageUrl: 'https://example.com/eulit.png',
    description: 'Relojes alemanes.',
    isActive: true,
  },
  {
    id: 174,
    name: 'Eulux',
    imageUrl: 'https://example.com/eulux.png',
    description: 'Relojes modernos.',
    isActive: false,
  },
  {
    id: 175,
    name: 'F.P.Journe',
    imageUrl: 'https://example.com/fp-journe.png',
    description: 'Relojes de alta relojería.',
    isActive: true,
  },
  {
    id: 176,
    name: 'Fabergé',
    imageUrl: 'https://example.com/faberge.png',
    description: 'Lujo y joyería.',
    isActive: false,
  },
  {
    id: 177,
    name: 'Favre-Leuba',
    imageUrl: 'https://example.com/favre-leuba.png',
    description: 'Relojes suizos clásicos.',
    isActive: true,
  },
  {
    id: 178,
    name: 'Feldo',
    imageUrl: 'https://example.com/feldo.png',
    description: 'Relojes alemanes.',
    isActive: false,
  },
  {
    id: 179,
    name: 'Fendi',
    imageUrl: 'https://example.com/fendi.png',
    description: 'Moda y lujo.',
    isActive: true,
  },
  {
    id: 180,
    name: 'Festina',
    imageUrl: 'https://example.com/festina.png',
    description: 'Relojes deportivos.',
    isActive: false,
  },
  {
    id: 181,
    name: 'Fiorucci',
    imageUrl: 'https://example.com/fiorucci.png',
    description: 'Estilo moderno.',
    isActive: true,
  },
  {
    id: 182,
    name: 'Flik Flak',
    imageUrl: 'https://example.com/flik-flak.png',
    description: 'Relojes para niños.',
    isActive: false,
  },
  {
    id: 183,
    name: 'Fluco',
    imageUrl: 'https://example.com/fluco.png',
    description: 'Relojes alemanes.',
    isActive: true,
  },
  {
    id: 184,
    name: 'Fludo',
    imageUrl: 'https://example.com/fludo.png',
    description: 'Relojes modernos.',
    isActive: false,
  },
  {
    id: 185,
    name: 'Formex',
    imageUrl: 'https://example.com/formex.png',
    description: 'Relojes suizos modernos.',
    isActive: true,
  },
  {
    id: 186,
    name: 'Fortis',
    imageUrl: 'https://example.com/fortis.png',
    description: 'Relojes de aviación.',
    isActive: false,
  },
  {
    id: 187,
    name: 'Forum',
    imageUrl: 'https://example.com/forum.png',
    description: 'Relojes modernos.',
    isActive: true,
  },
  {
    id: 188,
    name: 'Fossil',
    imageUrl: 'https://example.com/fossil.png',
    description: 'Estilo urbano.',
    isActive: false,
  },
  {
    id: 189,
    name: 'Franck Dubarry',
    imageUrl: 'https://example.com/franck-dubarry.png',
    description: 'Relojes de lujo.',
    isActive: true,
  },
  {
    id: 190,
    name: 'Franck Muller',
    imageUrl: 'brands/franck-muller.png',
    description: 'Relojes de alta relojería.',
    isActive: false,
  },
  {
    id: 191,
    name: 'Franc Vila',
    imageUrl: 'https://example.com/franc-vila.png',
    description: 'Relojes de alta gama.',
    isActive: true,
  },
  {
    id: 192,
    name: 'Frederique Constant',
    imageUrl: 'https://example.com/frederique-constant.png',
    description: 'Relojes suizos accesibles.',
    isActive: false,
  },
  {
    id: 193,
    name: 'Furlan Marri',
    imageUrl: 'https://example.com/furlan-marri.png',
    description: 'Relojes modernos.',
    isActive: true,
  },
  {
    id: 194,
    name: 'Gaga Milano',
    imageUrl: 'https://example.com/gaga-milano.png',
    description: 'Diseños italianos.',
    isActive: false,
  },
  {
    id: 195,
    name: 'Gallet',
    imageUrl: 'https://example.com/gallet.png',
    description: 'Relojes clásicos.',
    isActive: true,
  },
  {
    id: 196,
    name: 'Gant',
    imageUrl: 'https://example.com/gant.png',
    description: 'Estilo moderno.',
    isActive: false,
  },
  {
    id: 197,
    name: 'Gardé',
    imageUrl: 'https://example.com/garde.png',
    description: 'Relojes alemanes.',
    isActive: true,
  },
  {
    id: 198,
    name: 'Garmin',
    imageUrl: 'https://example.com/garmin.png',
    description: 'Relojes inteligentes.',
    isActive: false,
  },
  {
    id: 199,
    name: 'Georges V',
    imageUrl: 'https://example.com/georges-v.png',
    description: 'Relojes de lujo.',
    isActive: true,
  },
  {
    id: 200,
    name: 'Gérald Charles',
    imageUrl: 'https://example.com/gerald-charles.png',
    description: 'Relojes de alta relojería.',
    isActive: false,
  },
  {
    id: 201,
    name: 'Gérald Genta',
    imageUrl: 'https://example.com/gerald-genta.png',
    description: 'Diseños icónicos.',
    isActive: true,
  },
  {
    id: 202,
    name: 'Germano & Walter',
    imageUrl: 'https://example.com/germano-walter.png',
    description: 'Relojes artesanales.',
    isActive: false,
  },
  {
    id: 203,
    name: 'Gevril',
    imageUrl: 'https://example.com/gevrill.png',
    description: 'Relojes suizos modernos.',
    isActive: true,
  },
  {
    id: 204,
    name: 'Gigandet',
    imageUrl: 'https://example.com/gigandet.png',
    description: 'Relojes deportivos.',
    isActive: false,
  },
  {
    id: 205,
    name: 'Girard Perregaux',
    imageUrl: 'brands/girard-perregaux.png',
    description: 'Relojes de alta relojería.',
    isActive: true,
  },
  {
    id: 206,
    name: 'Giuliano Mazzuoli',
    imageUrl: 'https://example.com/giuliano-mazzuoli.png',
    description: 'Diseños italianos.',
    isActive: false,
  },
  {
    id: 207,
    name: 'Glashütte Original',
    imageUrl: 'brands/glashutte-original.png',
    description: 'Relojes alemanes de lujo.',
    isActive: true,
  },
  {
    id: 208,
    name: 'Glycine',
    imageUrl: 'https://example.com/glycine.png',
    description: 'Relojes suizos clásicos.',
    isActive: false,
  },
  {
    id: 209,
    name: 'Graf',
    imageUrl: 'https://example.com/graf.png',
    description: 'Relojes modernos.',
    isActive: true,
  },
  {
    id: 210,
    name: 'Graham',
    imageUrl: 'https://example.com/graham.png',
    description: 'Relojes de alta gama.',
    isActive: false,
  },
  {
    id: 211,
    name: 'Grand Seiko',
    imageUrl: 'https://example.com/grand-seiko.png',
    description: 'Relojes japoneses de alta precisión.',
    isActive: true,
  },
  {
    id: 212,
    name: 'Greubel Forsey',
    imageUrl: 'https://example.com/greubel-forsey.png',
    description: 'Relojes de alta relojería.',
    isActive: false,
  },
  {
    id: 213,
    name: 'Grönefeld',
    imageUrl: 'https://example.com/gronnefeld.png',
    description: 'Relojes artesanales.',
    isActive: true,
  },
  {
    id: 214,
    name: 'Grovana',
    imageUrl: 'https://example.com/grovana.png',
    description: 'Relojes suizos modernos.',
    isActive: false,
  },
  {
    id: 215,
    name: 'Gruen',
    imageUrl: 'https://example.com/gruen.png',
    description: 'Relojes clásicos americanos.',
    isActive: true,
  },
  {
    id: 216,
    name: 'Gübelin',
    imageUrl: 'https://example.com/gubelin.png',
    description: 'Relojes de lujo.',
    isActive: false,
  },
  {
    id: 217,
    name: 'GUB Glashütte',
    imageUrl: 'https://example.com/gub-glashutte.png',
    description: 'Relojes alemanes.',
    isActive: true,
  },
  {
    id: 218,
    name: 'Gucci',
    imageUrl: 'https://example.com/gucci.png',
    description: 'Moda y lujo.',
    isActive: false,
  },
  {
    id: 219,
    name: 'Guess',
    imageUrl: 'https://example.com/guess.png',
    description: 'Estilo moderno.',
    isActive: true,
  },
  {
    id: 220,
    name: 'Gul Watches',
    imageUrl: 'https://example.com/gul-watches.png',
    description: 'Relojes modernos.',
    isActive: false,
  },
  {
    id: 221,
    name: 'Guy Laroche',
    imageUrl: 'https://example.com/guy-laroche.png',
    description: 'Estilo elegante.',
    isActive: true,
  },
  {
    id: 222,
    name: 'H.I.D. Watch',
    imageUrl: 'https://example.com/hid-watch.png',
    description: 'Relojes modernos.',
    isActive: false,
  },
  {
    id: 223,
    name: 'H.Moser & Cie.',
    imageUrl: 'https://example.com/h-moser.png',
    description: 'Relojes de alta relojería.',
    isActive: true,
  },
  {
    id: 224,
    name: 'Habring²',
    imageUrl: 'https://example.com/habring.png',
    description: 'Relojes artesanales.',
    isActive: false,
  },
  {
    id: 225,
    name: 'Hacher',
    imageUrl: 'https://example.com/hacher.png',
    description: 'Relojes alemanes.',
    isActive: true,
  },
  {
    id: 226,
    name: 'Haemmer',
    imageUrl: 'https://example.com/haemmer.png',
    description: 'Relojes modernos.',
    isActive: false,
  },
  {
    id: 227,
    name: 'Hagal',
    imageUrl: 'https://example.com/hagal.png',
    description: 'Relojes modernos.',
    isActive: true,
  },
  {
    id: 228,
    name: 'Hamilton',
    imageUrl: 'https://example.com/hamilton.png',
    description: 'Relojes americanos clásicos.',
    isActive: false,
  },
  {
    id: 229,
    name: 'Hanhart',
    imageUrl: 'https://example.com/hanhart.png',
    description: 'Relojes alemanes.',
    isActive: true,
  },
  {
    id: 230,
    name: 'Harry Winston',
    imageUrl: 'https://example.com/harry-winston.png',
    description: 'Lujo y joyería.',
    isActive: false,
  },
  {
    id: 231,
    name: 'Hautlence',
    imageUrl: 'https://example.com/hautlence.png',
    description: 'Relojes de alta relojería.',
    isActive: true,
  },
  {
    id: 232,
    name: 'HD3',
    imageUrl: 'https://example.com/hd3.png',
    description: 'Diseños futuristas.',
    isActive: false,
  },
  {
    id: 233,
    name: 'Hebdomas',
    imageUrl: 'https://example.com/hebdomas.png',
    description: 'Relojes clásicos.',
    isActive: true,
  },
  {
    id: 234,
    name: 'Hebe',
    imageUrl: 'https://example.com/hebe.png',
    description: 'Relojes modernos.',
    isActive: false,
  },
  {
    id: 235,
    name: 'Helvetia',
    imageUrl: 'https://example.com/helvetia.png',
    description: 'Relojes suizos.',
    isActive: true,
  },
  {
    id: 236,
    name: 'Hentschel Hamburg',
    imageUrl: 'https://example.com/hentschel-hamburg.png',
    description: 'Relojes alemanes.',
    isActive: false,
  },
  {
    id: 237,
    name: 'Hermès',
    imageUrl: 'https://example.com/hermes.png',
    description: 'Lujo y moda.',
    isActive: true,
  },
  {
    id: 238,
    name: 'Herzog',
    imageUrl: 'https://example.com/herzog.png',
    description: 'Relojes modernos.',
    isActive: false,
  },
  {
    id: 239,
    name: 'Heuer',
    imageUrl: 'https://example.com/heuer.png',
    description: 'Relojes clásicos.',
    isActive: true,
  },
  {
    id: 240,
    name: 'Hirsch',
    imageUrl: 'https://example.com/hirsch.png',
    description: 'Relojes modernos.',
    isActive: false,
  },
  {
    id: 241,
    name: 'Hublot',
    imageUrl: 'brands/hublot.png',
    description: 'Relojes de lujo.',
    isActive: true,
  },
  {
    id: 242,
    name: 'Hugo Boss',
    imageUrl: 'https://example.com/hugo-boss.png',
    description: 'Moda y estilo.',
    isActive: false,
  },
  {
    id: 243,
    name: 'HYT',
    imageUrl: 'https://example.com/hyt.png',
    description: 'Relojes futuristas.',
    isActive: true,
  },
  {
    id: 244,
    name: 'Ice Watch',
    imageUrl: 'https://example.com/ice-watch.png',
    description: 'Relojes coloridos.',
    isActive: false,
  },
  {
    id: 245,
    name: 'Ikepod',
    imageUrl: 'https://example.com/ikepod.png',
    description: 'Diseños modernos.',
    isActive: true,
  },
  {
    id: 246,
    name: 'Illinois',
    imageUrl: 'https://example.com/illinois.png',
    description: 'Relojes clásicos americanos.',
    isActive: false,
  },
  {
    id: 247,
    name: 'Ingersoll',
    imageUrl: 'https://example.com/ingersoll.png',
    description: 'Relojes clásicos.',
    isActive: true,
  },
  {
    id: 248,
    name: 'Invicta',
    imageUrl: 'https://example.com/invicta.png',
    description: 'Relojes accesibles.',
    isActive: false,
  },
  {
    id: 249,
    name: 'Iron Annie',
    imageUrl: 'https://example.com/iron-annie.png',
    description: 'Relojes modernos.',
    isActive: true,
  },
  {
    id: 250,
    name: 'Itay Noy',
    imageUrl: 'https://example.com/itay-noy.png',
    description: 'Relojes artesanales.',
    isActive: false,
  },
  {
    id: 251,
    name: 'IWC',
    imageUrl: 'brands/iwc.png',
    description: 'Relojes de alta relojería.',
    isActive: true,
  },
  {
    id: 252,
    name: 'Jacob & Co.',
    imageUrl: 'https://example.com/jacob-co.png',
    description: 'Relojes de lujo.',
    isActive: false,
  },
  {
    id: 253,
    name: 'Jacques Etoile',
    imageUrl: 'https://example.com/jacques-etoile.png',
    description: 'Relojes suizos.',
    isActive: true,
  },
  {
    id: 254,
    name: 'Jacques Lemans',
    imageUrl: 'https://example.com/jacques-lemans.png',
    description: 'Relojes deportivos.',
    isActive: false,
  },
  {
    id: 255,
    name: 'Jaeger-LeCoultre',
    imageUrl: 'brands/jaeger-lecoultre.png',
    description: 'Relojes de alta relojería.',
    isActive: true,
  },
  {
    id: 256,
    name: 'Jaermann & Stübi',
    imageUrl: 'https://example.com/jaermann-stubi.png',
    description: 'Relojes suizos.',
    isActive: false,
  },
  {
    id: 257,
    name: 'Jaquet-Droz',
    imageUrl: 'https://example.com/jaquet-droz.png',
    description: 'Relojes artesanales.',
    isActive: true,
  },
  {
    id: 258,
    name: 'JB Gioacchino',
    imageUrl: 'https://example.com/jb-gioacchino.png',
    description: 'Relojes modernos.',
    isActive: false,
  },
  {
    id: 259,
    name: "Jean d'Eve",
    imageUrl: 'https://example.com/jean-deve.png',
    description: 'Relojes suizos.',
    isActive: true,
  },
  {
    id: 260,
    name: 'Jean Lassale',
    imageUrl: 'https://example.com/jean-lassale.png',
    description: 'Relojes de alta gama.',
    isActive: false,
  },
  {
    id: 261,
    name: 'Jean Marcel',
    imageUrl: 'https://example.com/jean-marcel.png',
    description: 'Relojes modernos.',
    isActive: true,
  },
  {
    id: 262,
    name: 'JeanRichard',
    imageUrl: 'https://example.com/jeanrichard.png',
    description: 'Relojes suizos.',
    isActive: false,
  },
  {
    id: 263,
    name: 'Joop',
    imageUrl: 'https://example.com/joop.png',
    description: 'Estilo moderno.',
    isActive: true,
  },
  {
    id: 264,
    name: 'Jorg Hysek',
    imageUrl: 'https://example.com/jorg-hysek.png',
    description: 'Diseños únicos.',
    isActive: false,
  },
  {
    id: 265,
    name: 'Jules Jürgensen',
    imageUrl: 'https://example.com/jules-jurgensen.png',
    description: 'Relojes clásicos.',
    isActive: true,
  },
  {
    id: 266,
    name: 'Junghans',
    imageUrl: 'https://example.com/junghans.png',
    description: 'Relojes alemanes.',
    isActive: false,
  },
  {
    id: 267,
    name: 'Junkers',
    imageUrl: 'https://example.com/junkers.png',
    description: 'Relojes alemanes.',
    isActive: true,
  },
  {
    id: 268,
    name: 'Justex',
    imageUrl: 'https://example.com/justex.png',
    description: 'Relojes modernos.',
    isActive: false,
  },
  {
    id: 269,
    name: 'Juvenia',
    imageUrl: 'https://example.com/juvenia.png',
    description: 'Relojes suizos.',
    isActive: true,
  },
  {
    id: 270,
    name: 'Kelek',
    imageUrl: 'https://example.com/kelek.png',
    description: 'Relojes suizos.',
    isActive: false,
  },
  {
    id: 271,
    name: 'KHS',
    imageUrl: 'https://example.com/khs.png',
    description: 'Relojes modernos.',
    isActive: true,
  },
  {
    id: 272,
    name: 'KHS-Watch',
    imageUrl: 'https://example.com/khs-watch.png',
    description: 'Relojes modernos.',
    isActive: false,
  },
  {
    id: 273,
    name: 'Kienzle',
    imageUrl: 'https://example.com/kienzle.png',
    description: 'Relojes alemanes.',
    isActive: true,
  },
  {
    id: 274,
    name: 'Kleber Uhrenatelier',
    imageUrl: 'https://example.com/kleber-uhrenatelier.png',
    description: 'Relojes artesanales.',
    isActive: false,
  },
  {
    id: 275,
    name: 'Kobold',
    imageUrl: 'https://example.com/kobold.png',
    description: 'Relojes robustos.',
    isActive: true,
  },
  {
    id: 276,
    name: 'Konstantin Chaykin',
    imageUrl: 'https://example.com/konstantin-chaykin.png',
    description: 'Relojes artesanales.',
    isActive: false,
  },
  {
    id: 277,
    name: 'Korloff',
    imageUrl: 'https://example.com/korloff.png',
    description: 'Relojes de lujo.',
    isActive: true,
  },
  {
    id: 278,
    name: 'Krieger',
    imageUrl: 'https://example.com/krieger.png',
    description: 'Relojes modernos.',
    isActive: false,
  },
  {
    id: 279,
    name: 'Kronsegler',
    imageUrl: 'https://example.com/kronsegler.png',
    description: 'Relojes modernos.',
    isActive: true,
  },
  {
    id: 280,
    name: 'L.Leroy',
    imageUrl: 'https://example.com/l-leroy.png',
    description: 'Relojes de alta relojería.',
    isActive: false,
  },
  {
    id: 281,
    name: "L'Epée",
    imageUrl: 'https://example.com/lepee.png',
    description: 'Relojes artesanales.',
    isActive: true,
  },
  {
    id: 282,
    name: 'Laco',
    imageUrl: 'https://example.com/laco.png',
    description: 'Relojes alemanes.',
    isActive: false,
  },
  {
    id: 283,
    name: 'Lacoste',
    imageUrl: 'https://example.com/lacoste.png',
    description: 'Estilo moderno.',
    isActive: true,
  },
  {
    id: 284,
    name: 'Lancaster',
    imageUrl: 'https://example.com/lancaster.png',
    description: 'Relojes modernos.',
    isActive: false,
  },
  {
    id: 285,
    name: 'Lanco',
    imageUrl: 'https://example.com/lanco.png',
    description: 'Relojes suizos.',
    isActive: true,
  },
  {
    id: 286,
    name: 'Lang & Heyne',
    imageUrl: 'https://example.com/lang-heyne.png',
    description: 'Relojes artesanales.',
    isActive: false,
  },
  {
    id: 287,
    name: 'Laurent Ferrier',
    imageUrl: 'https://example.com/laurent-ferrier.png',
    description: 'Relojes de alta relojería.',
    isActive: true,
  },
  {
    id: 288,
    name: 'Lebeau-Courally',
    imageUrl: 'https://example.com/lebeau-courally.png',
    description: 'Relojes de lujo.',
    isActive: false,
  },
  {
    id: 289,
    name: 'Leinfelder',
    imageUrl: 'https://example.com/leinfelder.png',
    description: 'Relojes alemanes.',
    isActive: true,
  },
  {
    id: 290,
    name: 'Lemania',
    imageUrl: 'https://example.com/lemania.png',
    description: 'Relojes clásicos.',
    isActive: false,
  },
  {
    id: 291,
    name: 'Leonidas',
    imageUrl: 'https://example.com/leonidas.png',
    description: 'Relojes suizos.',
    isActive: true,
  },
  {
    id: 292,
    name: 'Limes',
    imageUrl: 'https://example.com/limes.png',
    description: 'Relojes alemanes.',
    isActive: false,
  },
  {
    id: 293,
    name: 'Lindburgh + Benson',
    imageUrl: 'https://example.com/lindburgh-benson.png',
    description: 'Relojes modernos.',
    isActive: true,
  },
  {
    id: 294,
    name: 'Linde Werdelin',
    imageUrl: 'https://example.com/linde-werdelin.png',
    description: 'Relojes deportivos.',
    isActive: false,
  },
  {
    id: 295,
    name: 'Lip',
    imageUrl: 'https://example.com/lip.png',
    description: 'Relojes franceses.',
    isActive: true,
  },
  {
    id: 296,
    name: 'Liv Watches',
    imageUrl: 'https://example.com/liv-watches.png',
    description: 'Relojes modernos.',
    isActive: false,
  },
  {
    id: 297,
    name: 'Locman',
    imageUrl: 'https://example.com/locman.png',
    description: 'Relojes italianos.',
    isActive: true,
  },
  {
    id: 298,
    name: 'Longines',
    imageUrl: 'brands/longines.png',
    description: 'Relojes suizos clásicos.',
    isActive: false,
  },
  {
    id: 299,
    name: 'Longio',
    imageUrl: 'https://example.com/longio.png',
    description: 'Relojes modernos.',
    isActive: true,
  },
  {
    id: 300,
    name: 'Lorenz',
    imageUrl: 'https://example.com/lorenz.png',
    description: 'Relojes alemanes.',
    isActive: false,
  },
  {
    id: 301,
    name: 'Lorus',
    imageUrl: 'https://example.com/lorus.png',
    description: 'Relojes accesibles.',
    isActive: true,
  },
  {
    id: 302,
    name: 'Louis Erard',
    imageUrl: 'https://example.com/louis-erard.png',
    description: 'Relojes suizos.',
    isActive: false,
  },
  {
    id: 303,
    name: 'Louis Moinet',
    imageUrl: 'https://example.com/louis-moinet.png',
    description: 'Relojes de alta relojería.',
    isActive: true,
  },
  {
    id: 304,
    name: 'Louis Vuitton',
    imageUrl: 'https://example.com/louis-vuitton.png',
    description: 'Lujo y moda.',
    isActive: false,
  },
  {
    id: 305,
    name: 'Louis XVI',
    imageUrl: 'https://example.com/louis-xvi.png',
    description: 'Relojes de lujo.',
    isActive: true,
  },
  {
    id: 306,
    name: 'Lucien Rochat',
    imageUrl: 'https://example.com/lucien-rochat.png',
    description: 'Relojes suizos.',
    isActive: false,
  },
  {
    id: 307,
    name: 'Ludovic Ballouard',
    imageUrl: 'https://example.com/ludovic-ballouard.png',
    description: 'Relojes artesanales.',
    isActive: true,
  },
  {
    id: 308,
    name: 'Luminox',
    imageUrl: 'https://example.com/luminox.png',
    description: 'Relojes resistentes.',
    isActive: false,
  },
  {
    id: 309,
    name: 'Lüm-Tec',
    imageUrl: 'https://example.com/lum-tec.png',
    description: 'Relojes modernos.',
    isActive: true,
  },
  {
    id: 310,
    name: 'M.A.D. Editions',
    imageUrl: 'https://example.com/mad-editions.png',
    description: 'Relojes únicos.',
    isActive: false,
  },
  {
    id: 311,
    name: 'M&M Swiss Watch',
    imageUrl: 'https://example.com/m-m-swiss-watch.png',
    description: 'Relojes suizos.',
    isActive: true,
  },
  {
    id: 312,
    name: 'Marburger',
    imageUrl: 'https://example.com/marburger.png',
    description: 'Relojes alemanes.',
    isActive: false,
  },
  {
    id: 313,
    name: 'Marcello C.',
    imageUrl: 'https://example.com/marcello-c.png',
    description: 'Relojes modernos.',
    isActive: true,
  },
  {
    id: 314,
    name: 'Margi',
    imageUrl: 'https://example.com/margi.png',
    description: 'Relojes modernos.',
    isActive: false,
  },
  {
    id: 315,
    name: 'Marlboro',
    imageUrl: 'https://example.com/marlboro.png',
    description: 'Relojes promocionales.',
    isActive: true,
  },
  {
    id: 316,
    name: 'Martin Braun',
    imageUrl: 'https://example.com/martin-braun.png',
    description: 'Relojes artesanales.',
    isActive: false,
  },
  {
    id: 317,
    name: 'Marvin',
    imageUrl: 'https://example.com/marvin.png',
    description: 'Relojes suizos.',
    isActive: true,
  },
  {
    id: 318,
    name: 'Maserati',
    imageUrl: 'https://example.com/maserati.png',
    description: 'Relojes deportivos.',
    isActive: false,
  },
  {
    id: 319,
    name: 'Mathey-Tissot',
    imageUrl: 'https://example.com/mathey-tissot.png',
    description: 'Relojes suizos.',
    isActive: true,
  },
  {
    id: 320,
    name: 'Mauboussin',
    imageUrl: 'https://example.com/mauboussin.png',
    description: 'Relojes de lujo.',
    isActive: false,
  },
  {
    id: 321,
    name: 'Maurice Blum',
    imageUrl: 'https://example.com/maurice-blum.png',
    description: 'Relojes suizos.',
    isActive: true,
  },
  {
    id: 322,
    name: 'Maurice de Mauriac',
    imageUrl: 'https://example.com/maurice-de-mauriac.png',
    description: 'Relojes artesanales.',
    isActive: false,
  },
  {
    id: 323,
    name: 'Maurice Lacroix',
    imageUrl: 'brands/maurice-lacroix.png',
    description: 'Relojes suizos modernos.',
    isActive: true,
  },
  {
    id: 324,
    name: 'Mb&f',
    imageUrl: 'https://example.com/mb-f.png',
    description: 'Relojes de alta relojería.',
    isActive: false,
  },
  {
    id: 325,
    name: 'Meccaniche Veloci',
    imageUrl: 'https://example.com/meccaniche-veloci.png',
    description: 'Relojes italianos.',
    isActive: true,
  },
  {
    id: 326,
    name: 'Meistersinger',
    imageUrl: 'https://example.com/meistersinger.png',
    description: 'Relojes minimalistas.',
    isActive: false,
  },
  {
    id: 327,
    name: 'Mercure',
    imageUrl: 'https://example.com/mercure.png',
    description: 'Relojes modernos.',
    isActive: true,
  },
  {
    id: 328,
    name: 'Mercury',
    imageUrl: 'https://example.com/mercury.png',
    description: 'Relojes modernos.',
    isActive: false,
  },
  {
    id: 329,
    name: 'Meva',
    imageUrl: 'https://example.com/meva.png',
    description: 'Relojes modernos.',
    isActive: true,
  },
  {
    id: 330,
    name: 'MEXX Time',
    imageUrl: 'https://example.com/mexx-time.png',
    description: 'Relojes modernos.',
    isActive: false,
  },
  {
    id: 331,
    name: 'Meyers',
    imageUrl: 'https://example.com/meyers.png',
    description: 'Relojes modernos.',
    isActive: true,
  },
  {
    id: 332,
    name: 'Michael Bittel',
    imageUrl: 'https://example.com/michael-bittel.png',
    description: 'Relojes artesanales.',
    isActive: false,
  },
  {
    id: 333,
    name: 'Michael Kors',
    imageUrl: 'https://example.com/michael-kors.png',
    description: 'Moda y estilo.',
    isActive: true,
  },
  {
    id: 334,
    name: 'Michele',
    imageUrl: 'https://example.com/michele.png',
    description: 'Relojes de lujo.',
    isActive: false,
  },
  {
    id: 335,
    name: 'Michel Herbelin',
    imageUrl: 'https://example.com/michel-herbelin.png',
    description: 'Relojes franceses.',
    isActive: true,
  },
  {
    id: 336,
    name: 'Michel Jordi',
    imageUrl: 'https://example.com/michel-jordi.png',
    description: 'Relojes modernos.',
    isActive: false,
  },
  {
    id: 337,
    name: 'Mido',
    imageUrl: 'https://example.com/mido.png',
    description: 'Relojes suizos.',
    isActive: true,
  },
  {
    id: 338,
    name: 'Milleret',
    imageUrl: 'https://example.com/milleret.png',
    description: 'Relojes modernos.',
    isActive: false,
  },
  {
    id: 339,
    name: 'Milus',
    imageUrl: 'https://example.com/milus.png',
    description: 'Relojes suizos.',
    isActive: true,
  },
  {
    id: 340,
    name: 'Minerva',
    imageUrl: 'https://example.com/minerva.png',
    description: 'Relojes de alta relojería.',
    isActive: false,
  },
  {
    id: 341,
    name: 'Ming',
    imageUrl: 'https://example.com/ming.png',
    description: 'Relojes modernos.',
    isActive: true,
  },
  {
    id: 342,
    name: 'Momentum',
    imageUrl: 'https://example.com/momentum.png',
    description: 'Relojes deportivos.',
    isActive: false,
  },
  {
    id: 343,
    name: 'Momo Design',
    imageUrl: 'https://example.com/momo-design.png',
    description: 'Relojes modernos.',
    isActive: true,
  },
  {
    id: 344,
    name: 'Mondaine',
    imageUrl: 'https://example.com/mondaine.png',
    description: 'Relojes suizos.',
    isActive: false,
  },
  {
    id: 345,
    name: 'Mondia',
    imageUrl: 'https://example.com/mondia.png',
    description: 'Relojes modernos.',
    isActive: true,
  },
  {
    id: 346,
    name: 'Montano',
    imageUrl: 'https://example.com/montano.png',
    description: 'Relojes modernos.',
    isActive: false,
  },
  {
    id: 347,
    name: 'Montblanc',
    imageUrl: 'https://example.com/montblanc.png',
    description: 'Relojes de lujo.',
    isActive: true,
  },
  {
    id: 348,
    name: 'Montega',
    imageUrl: 'https://example.com/montega.png',
    description: 'Relojes modernos.',
    isActive: false,
  },
  {
    id: 349,
    name: 'Morellato',
    imageUrl: 'https://example.com/morellato.png',
    description: 'Relojes italianos.',
    isActive: true,
  },
  {
    id: 350,
    name: 'Moritz Grossmann',
    imageUrl: 'https://example.com/moritz-grossmann.png',
    description: 'Relojes alemanes.',
    isActive: false,
  },
  {
    id: 351,
    name: 'Movado',
    imageUrl: 'https://example.com/movado.png',
    description: 'Relojes modernos.',
    isActive: true,
  },
  {
    id: 352,
    name: 'Mühle Glashütte',
    imageUrl: 'https://example.com/muhle-glashutte.png',
    description: 'Relojes alemanes.',
    isActive: false,
  },
  {
    id: 353,
    name: 'N.B. Yäeger',
    imageUrl: 'https://example.com/nb-yaeger.png',
    description: 'Relojes modernos.',
    isActive: true,
  },
  {
    id: 354,
    name: 'N.O.A',
    imageUrl: 'https://example.com/noa.png',
    description: 'Relojes modernos.',
    isActive: false,
  },
  {
    id: 355,
    name: 'Naj-Oleari',
    imageUrl: 'https://example.com/naj-oleari.png',
    description: 'Relojes modernos.',
    isActive: true,
  },
  {
    id: 356,
    name: 'Nautica',
    imageUrl: 'https://example.com/nautica.png',
    description: 'Relojes deportivos.',
    isActive: false,
  },
  {
    id: 357,
    name: 'Nauticfish',
    imageUrl: 'https://example.com/nauticfish.png',
    description: 'Relojes de buceo.',
    isActive: true,
  },
  {
    id: 358,
    name: 'Nethuns',
    imageUrl: 'https://example.com/nethuns.png',
    description: 'Relojes modernos.',
    isActive: false,
  },
  {
    id: 359,
    name: 'Nike',
    imageUrl: 'https://example.com/nike.png',
    description: 'Relojes deportivos.',
    isActive: true,
  },
  {
    id: 360,
    name: 'Nina Ricci',
    imageUrl: 'https://example.com/nina-ricci.png',
    description: 'Moda y estilo.',
    isActive: false,
  },
  {
    id: 361,
    name: 'Nivada',
    imageUrl: 'https://example.com/nivada.png',
    description: 'Relojes suizos.',
    isActive: true,
  },
  {
    id: 362,
    name: 'Nivrel',
    imageUrl: 'https://example.com/nivrel.png',
    description: 'Relojes modernos.',
    isActive: false,
  },
  {
    id: 363,
    name: 'Nixon',
    imageUrl: 'https://example.com/nixon.png',
    description: 'Relojes modernos.',
    isActive: true,
  },
  {
    id: 364,
    name: 'NOMOS',
    imageUrl: 'https://example.com/nomos.png',
    description: 'Relojes alemanes minimalistas.',
    isActive: false,
  },
  {
    id: 365,
    name: 'Norqain',
    imageUrl: 'https://example.com/norqain.png',
    description: 'Relojes suizos modernos.',
    isActive: true,
  },
  {
    id: 366,
    name: 'Nouvelle Horlogerie Calabrese (NHC)',
    imageUrl: 'https://example.com/nhc.png',
    description: 'Relojes artesanales.',
    isActive: false,
  },
  {
    id: 367,
    name: 'ODM',
    imageUrl: 'https://example.com/odm.png',
    description: 'Relojes modernos.',
    isActive: true,
  },
  {
    id: 368,
    name: 'Officina del Tempo',
    imageUrl: 'https://example.com/officina-del-tempo.png',
    description: 'Relojes italianos.',
    isActive: false,
  },
  {
    id: 369,
    name: 'Offshore Limited',
    imageUrl: 'https://example.com/offshore-limited.png',
    description: 'Relojes deportivos.',
    isActive: true,
  },
  {
    id: 370,
    name: 'Ollech & Wajs',
    imageUrl: 'https://example.com/ollech-wajs.png',
    description: 'Relojes clásicos.',
    isActive: false,
  },
  {
    id: 371,
    name: 'Omega',
    imageUrl: 'brands/omega.png',
    description: 'Relojes suizos de alta gama.',
    isActive: true,
  },
  {
    id: 372,
    name: 'Orator',
    imageUrl: 'https://example.com/orator.png',
    description: 'Relojes modernos.',
    isActive: false,
  },
  {
    id: 373,
    name: 'Orbita',
    imageUrl: 'https://example.com/orbita.png',
    description: 'Relojes modernos.',
    isActive: true,
  },
  {
    id: 374,
    name: 'Orfina',
    imageUrl: 'https://example.com/orfina.png',
    description: 'Relojes suizos.',
    isActive: false,
  },
  {
    id: 375,
    name: 'Orient',
    imageUrl: 'https://example.com/orient.png',
    description: 'Relojes japoneses.',
    isActive: true,
  },
  {
    id: 376,
    name: 'Oris',
    imageUrl: 'https://example.com/oris.png',
    description: 'Relojes suizos.',
    isActive: false,
  },
  {
    id: 377,
    name: 'Otumm',
    imageUrl: 'https://example.com/otumm.png',
    description: 'Relojes modernos.',
    isActive: true,
  },
  {
    id: 378,
    name: 'Out of Order',
    imageUrl: 'https://example.com/out-of-order.png',
    description: 'Relojes modernos.',
    isActive: false,
  },
  {
    id: 379,
    name: 'Pacardt',
    imageUrl: 'https://example.com/pacardt.png',
    description: 'Relojes modernos.',
    isActive: true,
  },
  {
    id: 380,
    name: 'Panerai',
    imageUrl: 'panerai/panerai.png',
    description: 'Relojes de lujo.',
    isActive: false,
  },
  {
    id: 381,
    name: 'Parmigiani Fleurier',
    imageUrl: 'https://example.com/parmigiani-fleurier.png',
    description: 'Relojes de alta relojería.',
    isActive: true,
  },
  {
    id: 382,
    name: 'Patek Philippe',
    imageUrl: 'brands/patek-philippe.png',
    description: 'Relojes de alta relojería.',
    isActive: false,
  },
  {
    id: 383,
    name: 'Paul Picot',
    imageUrl: 'https://example.com/paul-picot.png',
    description: 'Relojes suizos.',
    isActive: true,
  },
  {
    id: 384,
    name: 'Pequignet',
    imageUrl: 'https://example.com/pequignet.png',
    description: 'Relojes franceses.',
    isActive: false,
  },
  {
    id: 385,
    name: 'Perigáum',
    imageUrl: 'https://example.com/perigaum.png',
    description: 'Relojes modernos.',
    isActive: true,
  },
  {
    id: 386,
    name: 'Perrelet',
    imageUrl: 'https://example.com/perrelet.png',
    description: 'Relojes suizos.',
    isActive: false,
  },
  {
    id: 387,
    name: 'Perseo',
    imageUrl: 'https://example.com/perseo.png',
    description: 'Relojes modernos.',
    isActive: true,
  },
  {
    id: 388,
    name: 'Phantoms',
    imageUrl: 'https://example.com/phantoms.png',
    description: 'Relojes modernos.',
    isActive: false,
  },
  {
    id: 389,
    name: 'Philip Stein',
    imageUrl: 'https://example.com/philip-stein.png',
    description: 'Relojes modernos.',
    isActive: true,
  },
  {
    id: 390,
    name: 'Philip Watch',
    imageUrl: 'https://example.com/philip-watch.png',
    description: 'Relojes modernos.',
    isActive: false,
  },
  {
    id: 391,
    name: 'Piaget',
    imageUrl: 'https://example.com/piaget.png',
    description: 'Relojes de lujo.',
    isActive: true,
  },
  {
    id: 392,
    name: 'Pierre Balmain',
    imageUrl: 'https://example.com/pierre-balmain.png',
    description: 'Moda y estilo.',
    isActive: false,
  },
  {
    id: 393,
    name: 'Pierre Cardin',
    imageUrl: 'https://example.com/pierre-cardin.png',
    description: 'Moda y estilo.',
    isActive: true,
  },
  {
    id: 394,
    name: 'Pierre DeRoche',
    imageUrl: 'https://example.com/pierre-deroche.png',
    description: 'Relojes suizos.',
    isActive: false,
  },
  {
    id: 395,
    name: 'Pierre Kunz',
    imageUrl: 'https://example.com/pierre-kunz.png',
    description: 'Relojes modernos.',
    isActive: true,
  },
  {
    id: 396,
    name: 'Police',
    imageUrl: 'https://example.com/police.png',
    description: 'Relojes modernos.',
    isActive: false,
  },
  {
    id: 397,
    name: 'Poljot',
    imageUrl: 'https://example.com/poljot.png',
    description: 'Relojes rusos.',
    isActive: true,
  },
  {
    id: 398,
    name: 'Porsche Design',
    imageUrl: 'https://example.com/porsche-design.png',
    description: 'Relojes deportivos.',
    isActive: false,
  },
  {
    id: 399,
    name: 'Preisig Schaffhausen',
    imageUrl: 'https://example.com/preisig-schaffhausen.png',
    description: 'Relojes suizos.',
    isActive: true,
  },
  {
    id: 400,
    name: 'Prim',
    imageUrl: 'https://example.com/prim.png',
    description: 'Relojes modernos.',
    isActive: false,
  },
  {
    id: 401,
    name: 'Pro-Hunter',
    imageUrl: 'https://example.com/pro-hunter.png',
    description: 'Relojes resistentes.',
    isActive: true,
  },
  {
    id: 402,
    name: 'Pryngeps',
    imageUrl: 'https://example.com/pryngeps.png',
    description: 'Relojes modernos.',
    isActive: false,
  },
  {
    id: 403,
    name: 'Pulsar',
    imageUrl: 'https://example.com/pulsar.png',
    description: 'Relojes modernos.',
    isActive: true,
  },
  {
    id: 404,
    name: 'Puma',
    imageUrl: 'https://example.com/puma.png',
    description: 'Relojes deportivos.',
    isActive: false,
  },
  {
    id: 405,
    name: 'Quinting',
    imageUrl: 'https://example.com/quinting.png',
    description: 'Relojes transparentes.',
    isActive: true,
  },
  {
    id: 406,
    name: 'Rado',
    imageUrl: 'https://example.com/rado.png',
    description: 'Relojes suizos modernos.',
    isActive: false,
  },
  {
    id: 407,
    name: 'Raidillon',
    imageUrl: 'https://example.com/raidillon.png',
    description: 'Relojes modernos.',
    isActive: true,
  },
  {
    id: 408,
    name: 'Rainer Brand',
    imageUrl: 'https://example.com/rainer-brand.png',
    description: 'Relojes modernos.',
    isActive: false,
  },
  {
    id: 409,
    name: 'Rainer Nienaber',
    imageUrl: 'https://example.com/rainer-nienaber.png',
    description: 'Relojes modernos.',
    isActive: true,
  },
  {
    id: 410,
    name: 'Raketa',
    imageUrl: 'https://example.com/raketa.png',
    description: 'Relojes rusos.',
    isActive: false,
  },
  {
    id: 411,
    name: 'Ralf Tech',
    imageUrl: 'https://example.com/ralf-tech.png',
    description: 'Relojes deportivos.',
    isActive: true,
  },
  {
    id: 412,
    name: 'Ralph Lauren',
    imageUrl: 'https://example.com/ralph-lauren.png',
    description: 'Moda y estilo.',
    isActive: false,
  },
  {
    id: 413,
    name: 'Raymond Weil',
    imageUrl: 'https://example.com/raymond-weil.png',
    description: 'Relojes suizos.',
    isActive: true,
  },
  {
    id: 414,
    name: 'Rebellion',
    imageUrl: 'https://example.com/rebellion.png',
    description: 'Relojes de alta relojería.',
    isActive: false,
  },
  {
    id: 415,
    name: 'Record',
    imageUrl: 'https://example.com/record.png',
    description: 'Relojes suizos.',
    isActive: true,
  },
  {
    id: 416,
    name: 'REC Watches',
    imageUrl: 'https://example.com/rec-watches.png',
    description: 'Relojes modernos.',
    isActive: false,
  },
  {
    id: 417,
    name: 'René Mouris',
    imageUrl: 'https://example.com/rene-mouris.png',
    description: 'Relojes modernos.',
    isActive: true,
  },
  {
    id: 418,
    name: 'Ressence',
    imageUrl: 'https://example.com/ressence.png',
    description: 'Relojes innovadores.',
    isActive: false,
  },
  {
    id: 419,
    name: 'Revue Thommen',
    imageUrl: 'https://example.com/revue-thommen.png',
    description: 'Relojes suizos.',
    isActive: true,
  },
  {
    id: 420,
    name: 'RGM',
    imageUrl: 'https://example.com/rgm.png',
    description: 'Relojes americanos.',
    isActive: false,
  },
  {
    id: 421,
    name: 'Richard Mille',
    imageUrl: 'https://example.com/richard-mille.png',
    description: 'Relojes de alta relojería.',
    isActive: true,
  },
  {
    id: 422,
    name: 'Rios1931',
    imageUrl: 'https://example.com/rios1931.png',
    description: 'Relojes modernos.',
    isActive: false,
  },
  {
    id: 423,
    name: 'Roamer',
    imageUrl: 'https://example.com/roamer.png',
    description: 'Relojes suizos.',
    isActive: true,
  },
  {
    id: 424,
    name: 'Roger Dubuis',
    imageUrl: 'https://example.com/roger-dubuis.png',
    description: 'Relojes de alta relojería.',
    isActive: false,
  },
  {
    id: 425,
    name: 'Rolex',
    imageUrl: 'brands/rolex.png',
    description: 'Relojes de lujo.',
    isActive: true,
  },
  {
    id: 426,
    name: 'Rolf Lang',
    imageUrl: 'https://example.com/rolf-lang.png',
    description: 'Relojes modernos.',
    isActive: false,
  },
  {
    id: 427,
    name: 'Romain Jerome',
    imageUrl: 'https://example.com/romain-jerome.png',
    description: 'Relojes de lujo.',
    isActive: true,
  },
  {
    id: 428,
    name: 'Rotary',
    imageUrl: 'https://example.com/rotary.png',
    description: 'Relojes británicos.',
    isActive: false,
  },
  {
    id: 429,
    name: 'Rothenschild',
    imageUrl: 'https://example.com/rothenschild.png',
    description: 'Relojes modernos.',
    isActive: true,
  },
  {
    id: 430,
    name: 'ROWI',
    imageUrl: 'https://example.com/rowi.png',
    description: 'Relojes modernos.',
    isActive: false,
  },
  {
    id: 431,
    name: 'RSW',
    imageUrl: 'https://example.com/rsw.png',
    description: 'Relojes modernos.',
    isActive: true,
  },
  {
    id: 432,
    name: 'Ryser Kentfield',
    imageUrl: 'https://example.com/ryser-kentfield.png',
    description: 'Relojes modernos.',
    isActive: false,
  },
  {
    id: 433,
    name: 'S.Oliver',
    imageUrl: 'https://example.com/s-oliver.png',
    description: 'Estilo moderno.',
    isActive: true,
  },
  {
    id: 434,
    name: 'S.T. Dupont',
    imageUrl: 'https://example.com/st-dupont.png',
    description: 'Relojes de lujo.',
    isActive: false,
  },
  {
    id: 435,
    name: 'Salvatore Ferragamo',
    imageUrl: 'https://example.com/salvatore-ferragamo.png',
    description: 'Moda y estilo.',
    isActive: true,
  },
  {
    id: 436,
    name: 'Sandoz',
    imageUrl: 'https://example.com/sandoz.png',
    description: 'Relojes suizos.',
    isActive: false,
  },
  {
    id: 437,
    name: 'Sarcar',
    imageUrl: 'https://example.com/sarcar.png',
    description: 'Relojes de lujo.',
    isActive: true,
  },
  {
    id: 438,
    name: 'Scalfaro',
    imageUrl: 'https://example.com/scalfaro.png',
    description: 'Relojes modernos.',
    isActive: false,
  },
  {
    id: 439,
    name: 'Schäuble & Söhne',
    imageUrl: 'https://example.com/schauble-sohne.png',
    description: 'Relojes alemanes.',
    isActive: true,
  },
  {
    id: 440,
    name: 'Schaumburg',
    imageUrl: 'https://example.com/schaumburg.png',
    description: 'Relojes modernos.',
    isActive: false,
  },
  {
    id: 441,
    name: 'Schwarz Etienne',
    imageUrl: 'https://example.com/schwarz-etienne.png',
    description: 'Relojes suizos.',
    isActive: true,
  },
  {
    id: 442,
    name: 'Sea-God',
    imageUrl: 'https://example.com/sea-god.png',
    description: 'Relojes modernos.',
    isActive: false,
  },
  {
    id: 443,
    name: 'Sea-Gull',
    imageUrl: 'https://example.com/sea-gull.png',
    description: 'Relojes chinos.',
    isActive: true,
  },
  {
    id: 444,
    name: 'Sector',
    imageUrl: 'https://example.com/sector.png',
    description: 'Relojes modernos.',
    isActive: false,
  },
  {
    id: 445,
    name: 'Seiko',
    imageUrl: 'https://example.com/seiko.png',
    description: 'Relojes japoneses.',
    isActive: true,
  },
  {
    id: 446,
    name: 'Sekford',
    imageUrl: 'https://example.com/sekford.png',
    description: 'Relojes modernos.',
    isActive: false,
  },
  {
    id: 447,
    name: 'Sevenfriday',
    imageUrl: 'https://example.com/sevenfriday.png',
    description: 'Relojes modernos.',
    isActive: true,
  },
  {
    id: 448,
    name: 'Shinola',
    imageUrl: 'https://example.com/shinola.png',
    description: 'Relojes americanos.',
    isActive: false,
  },
  {
    id: 449,
    name: 'Sicura',
    imageUrl: 'https://example.com/sicura.png',
    description: 'Relojes modernos.',
    isActive: true,
  },
  {
    id: 450,
    name: 'Sinn',
    imageUrl: 'brands/sinn.png',
    description: 'Relojes alemanes.',
    isActive: false,
  },
  {
    id: 451,
    name: 'Skagen',
    imageUrl: 'https://example.com/skagen.png',
    description: 'Relojes modernos.',
    isActive: true,
  },
  {
    id: 452,
    name: 'Slava',
    imageUrl: 'https://example.com/slava.png',
    description: 'Relojes rusos.',
    isActive: false,
  },
  {
    id: 453,
    name: 'Snyper',
    imageUrl: 'https://example.com/snyper.png',
    description: 'Relojes modernos.',
    isActive: true,
  },
  {
    id: 454,
    name: 'Sothis',
    imageUrl: 'https://example.com/sothis.png',
    description: 'Relojes modernos.',
    isActive: false,
  },
  {
    id: 455,
    name: 'Speake-Marin',
    imageUrl: 'https://example.com/speake-marin.png',
    description: 'Relojes de alta relojería.',
    isActive: true,
  },
  {
    id: 456,
    name: 'Spinnaker',
    imageUrl: 'https://example.com/spinnaker.png',
    description: 'Relojes deportivos.',
    isActive: false,
  },
  {
    id: 457,
    name: 'Squale',
    imageUrl: 'https://example.com/squale.png',
    description: 'Relojes de buceo.',
    isActive: true,
  },
  {
    id: 458,
    name: 'St. Gallen',
    imageUrl: 'https://example.com/st-gallen.png',
    description: 'Relojes modernos.',
    isActive: false,
  },
  {
    id: 459,
    name: 'Starkiin',
    imageUrl: 'https://example.com/starkiin.png',
    description: 'Relojes modernos.',
    isActive: true,
  },
  {
    id: 460,
    name: 'Steelcraft',
    imageUrl: 'https://example.com/steelcraft.png',
    description: 'Relojes modernos.',
    isActive: false,
  },
  {
    id: 461,
    name: 'Steinhart',
    imageUrl: 'https://example.com/steinhart.png',
    description: 'Relojes alemanes.',
    isActive: true,
  },
  {
    id: 462,
    name: 'Stowa',
    imageUrl: 'https://example.com/stowa.png',
    description: 'Relojes alemanes.',
    isActive: false,
  },
  {
    id: 463,
    name: 'Strom',
    imageUrl: 'https://example.com/strom.png',
    description: 'Relojes modernos.',
    isActive: true,
  },
  {
    id: 464,
    name: 'Stuhrling',
    imageUrl: 'https://example.com/stuhrling.png',
    description: 'Relojes modernos.',
    isActive: false,
  },
  {
    id: 465,
    name: 'Swatch',
    imageUrl: 'https://example.com/swatch.png',
    description: 'Relojes coloridos.',
    isActive: true,
  },
  {
    id: 466,
    name: 'Swiss Military',
    imageUrl: 'https://example.com/swiss-military.png',
    description: 'Relojes resistentes.',
    isActive: false,
  },
  {
    id: 467,
    name: 'TAG Heuer',
    imageUrl: 'brands/tag-heuer.png',
    description: 'Relojes deportivos.',
    isActive: true,
  },
  {
    id: 468,
    name: 'Tavannes',
    imageUrl: 'https://example.com/tavannes.png',
    description: 'Relojes suizos.',
    isActive: false,
  },
  {
    id: 469,
    name: 'TB Buti',
    imageUrl: 'https://example.com/tb-buti.png',
    description: 'Relojes modernos.',
    isActive: true,
  },
  {
    id: 470,
    name: 'Technomarine',
    imageUrl: 'https://example.com/technomarine.png',
    description: 'Relojes deportivos.',
    isActive: false,
  },
  {
    id: 471,
    name: 'Technos',
    imageUrl: 'https://example.com/technos.png',
    description: 'Relojes modernos.',
    isActive: true,
  },
  {
    id: 472,
    name: 'Tecnotempo',
    imageUrl: 'https://example.com/tecnotempo.png',
    description: 'Relojes modernos.',
    isActive: false,
  },
  {
    id: 473,
    name: 'Temption',
    imageUrl: 'https://example.com/temption.png',
    description: 'Relojes modernos.',
    isActive: true,
  },
  {
    id: 474,
    name: 'Tempvs Compvtare',
    imageUrl: 'https://example.com/tempvs-compvtare.png',
    description: 'Relojes modernos.',
    isActive: false,
  },
  {
    id: 475,
    name: 'Tendence',
    imageUrl: 'https://example.com/tendence.png',
    description: 'Relojes modernos.',
    isActive: true,
  },
  {
    id: 476,
    name: 'Terra Cielo Mare',
    imageUrl: 'https://example.com/terra-cielo-mare.png',
    description: 'Relojes modernos.',
    isActive: false,
  },
  {
    id: 477,
    name: 'Theorein',
    imageUrl: 'https://example.com/theorein.png',
    description: 'Relojes modernos.',
    isActive: true,
  },
  {
    id: 478,
    name: 'Thomas Ninchritz',
    imageUrl: 'https://example.com/thomas-ninchritz.png',
    description: 'Relojes modernos.',
    isActive: false,
  },
  {
    id: 479,
    name: 'Thorr',
    imageUrl: 'https://example.com/thorr.png',
    description: 'Relojes modernos.',
    isActive: true,
  },
  {
    id: 480,
    name: 'Tiffany',
    imageUrl: 'https://example.com/tiffany.png',
    description: 'Relojes de lujo.',
    isActive: false,
  },
  {
    id: 481,
    name: 'Timberland Watches',
    imageUrl: 'https://example.com/timberland-watches.png',
    description: 'Relojes modernos.',
    isActive: true,
  },
  {
    id: 482,
    name: 'Timex',
    imageUrl: 'https://example.com/timex.png',
    description: 'Relojes accesibles.',
    isActive: false,
  },
  {
    id: 483,
    name: 'Tissot',
    imageUrl: 'https://example.com/tissot.png',
    description: 'Relojes suizos.',
    isActive: true,
  },
  {
    id: 484,
    name: 'Titus',
    imageUrl: 'https://example.com/titus.png',
    description: 'Relojes modernos.',
    isActive: false,
  },
  {
    id: 485,
    name: 'Tokyo Flash',
    imageUrl: 'https://example.com/tokyo-flash.png',
    description: 'Relojes futuristas.',
    isActive: true,
  },
  {
    id: 486,
    name: 'Tommy Hilfiger',
    imageUrl: 'https://example.com/tommy-hilfiger.png',
    description: 'Moda y estilo.',
    isActive: false,
  },
  {
    id: 487,
    name: 'Tonino Lamborghini',
    imageUrl: 'https://example.com/tonino-lamborghini.png',
    description: 'Relojes de lujo.',
    isActive: true,
  },
  {
    id: 488,
    name: 'Torrini',
    imageUrl: 'https://example.com/torrini.png',
    description: 'Relojes modernos.',
    isActive: false,
  },
  {
    id: 489,
    name: 'Traser',
    imageUrl: 'https://example.com/traser.png',
    description: 'Relojes resistentes.',
    isActive: true,
  },
  {
    id: 490,
    name: 'Tudor',
    imageUrl: 'brands/tudor.png',
    description: 'Relojes de lujo.',
    isActive: false,
  },
  {
    id: 491,
    name: 'Tutima',
    imageUrl: 'https://example.com/tutima.png',
    description: 'Relojes alemanes.',
    isActive: true,
  },
  {
    id: 492,
    name: 'TW Steel',
    imageUrl: 'https://example.com/tw-steel.png',
    description: 'Relojes modernos.',
    isActive: false,
  },
  {
    id: 493,
    name: 'Ublast',
    imageUrl: 'https://example.com/ublast.png',
    description: 'Relojes modernos.',
    isActive: true,
  },
  {
    id: 494,
    name: 'U-Boat',
    imageUrl: 'https://example.com/u-boat.png',
    description: 'Relojes robustos.',
    isActive: false,
  },
  {
    id: 495,
    name: 'Ulysse Nardin',
    imageUrl: 'https://example.com/ulysse-nardin.png',
    description: 'Relojes de alta relojería.',
    isActive: true,
  },
  {
    id: 496,
    name: 'Unikatuhren',
    imageUrl: 'https://example.com/unikatuhren.png',
    description: 'Relojes únicos.',
    isActive: false,
  },
  {
    id: 497,
    name: 'Union Glashütte',
    imageUrl: 'https://example.com/union-glashutte.png',
    description: 'Relojes alemanes.',
    isActive: true,
  },
  {
    id: 498,
    name: 'Universal Genève',
    imageUrl: 'https://example.com/universal-geneve.png',
    description: 'Relojes clásicos.',
    isActive: false,
  },
  {
    id: 499,
    name: 'Urban Jürgensen',
    imageUrl: 'https://example.com/urban-jurgensen.png',
    description: 'Relojes de alta relojería.',
    isActive: true,
  },
  {
    id: 500,
    name: 'Urwerk',
    imageUrl: 'https://example.com/urwerk.png',
    description: 'Relojes futuristas.',
    isActive: false,
  },
  {
    id: 501,
    name: 'Vacheron Constantin',
    imageUrl: 'https://example.com/vacheron-constantin.png',
    description: 'Relojes de alta relojería.',
    isActive: true,
  },
  {
    id: 502,
    name: 'Valbray',
    imageUrl: 'https://example.com/valbray.png',
    description: 'Relojes modernos.',
    isActive: false,
  },
  {
    id: 503,
    name: 'Valentino',
    imageUrl: 'https://example.com/valentino.png',
    description: 'Moda y estilo.',
    isActive: true,
  },
  {
    id: 504,
    name: 'Van Cleef & Arpels',
    imageUrl: 'https://example.com/van-cleef-arpels.png',
    description: 'Relojes de lujo.',
    isActive: false,
  },
  {
    id: 505,
    name: 'Van Der Bauwede',
    imageUrl: 'https://example.com/van-der-bauwede.png',
    description: 'Relojes modernos.',
    isActive: true,
  },
  {
    id: 506,
    name: 'Vangarde',
    imageUrl: 'https://example.com/vangarde.png',
    description: 'Relojes modernos.',
    isActive: false,
  },
  {
    id: 507,
    name: 'Venezianico',
    imageUrl: 'https://example.com/venezianico.png',
    description: 'Relojes italianos.',
    isActive: true,
  },
  {
    id: 508,
    name: 'Ventura',
    imageUrl: 'https://example.com/ventura.png',
    description: 'Relojes modernos.',
    isActive: false,
  },
  {
    id: 509,
    name: 'Versace',
    imageUrl: 'https://example.com/versace.png',
    description: 'Moda y estilo.',
    isActive: true,
  },
  {
    id: 510,
    name: 'Vianney Halter',
    imageUrl: 'https://example.com/vianney-halter.png',
    description: 'Relojes artesanales.',
    isActive: false,
  },
  {
    id: 511,
    name: 'Viceroy',
    imageUrl: 'https://example.com/viceroy.png',
    description: 'Relojes modernos.',
    isActive: true,
  },
  {
    id: 512,
    name: 'Victorinox Swiss Army',
    imageUrl: 'https://example.com/victorinox.png',
    description: 'Relojes resistentes.',
    isActive: false,
  },
  {
    id: 513,
    name: 'Vigoria Miletto',
    imageUrl: 'https://example.com/vigoria-miletto.png',
    description: 'Relojes modernos.',
    isActive: true,
  },
  {
    id: 514,
    name: 'Villemont',
    imageUrl: 'https://example.com/villemont.png',
    description: 'Relojes modernos.',
    isActive: false,
  },
  {
    id: 515,
    name: 'Vincent Calabrese',
    imageUrl: 'https://example.com/vincent-calabrese.png',
    description: 'Relojes artesanales.',
    isActive: true,
  },
  {
    id: 516,
    name: 'Visconti',
    imageUrl: 'https://example.com/visconti.png',
    description: 'Relojes modernos.',
    isActive: false,
  },
  {
    id: 517,
    name: 'Vixa',
    imageUrl: 'https://example.com/vixa.png',
    description: 'Relojes modernos.',
    isActive: true,
  },
  {
    id: 518,
    name: 'Vogard',
    imageUrl: 'https://example.com/vogard.png',
    description: 'Relojes modernos.',
    isActive: false,
  },
  {
    id: 519,
    name: 'Vollmer',
    imageUrl: 'https://example.com/vollmer.png',
    description: 'Relojes modernos.',
    isActive: true,
  },
  {
    id: 520,
    name: 'Volna',
    imageUrl: 'https://example.com/volna.png',
    description: 'Relojes rusos.',
    isActive: false,
  },
  {
    id: 521,
    name: 'Vostok',
    imageUrl: 'https://example.com/vostok.png',
    description: 'Relojes rusos.',
    isActive: true,
  },
  {
    id: 522,
    name: 'Voutilainen',
    imageUrl: 'https://example.com/voutilainen.png',
    description: 'Relojes artesanales.',
    isActive: false,
  },
  {
    id: 523,
    name: 'Vulcain',
    imageUrl: 'https://example.com/vulcain.png',
    description: 'Relojes clásicos.',
    isActive: true,
  },
  {
    id: 524,
    name: 'Wakmann',
    imageUrl: 'https://example.com/wakmann.png',
    description: 'Relojes clásicos.',
    isActive: false,
  },
  {
    id: 525,
    name: 'Waltham',
    imageUrl: 'https://example.com/waltham.png',
    description: 'Relojes americanos.',
    isActive: true,
  },
  {
    id: 526,
    name: 'Welder',
    imageUrl: 'https://example.com/welder.png',
    description: 'Relojes modernos.',
    isActive: false,
  },
  {
    id: 527,
    name: 'Wempe',
    imageUrl: 'https://example.com/wempe.png',
    description: 'Relojes alemanes.',
    isActive: true,
  },
  {
    id: 528,
    name: 'Wenger',
    imageUrl: 'https://example.com/wenger.png',
    description: 'Relojes suizos.',
    isActive: false,
  },
  {
    id: 529,
    name: 'Werenbach',
    imageUrl: 'https://example.com/werenbach.png',
    description: 'Relojes modernos.',
    isActive: true,
  },
  {
    id: 530,
    name: 'Wittnauer',
    imageUrl: 'https://example.com/wittnauer.png',
    description: 'Relojes americanos.',
    isActive: false,
  },
  {
    id: 531,
    name: 'Wyler',
    imageUrl: 'https://example.com/wyler.png',
    description: 'Relojes modernos.',
    isActive: true,
  },
  {
    id: 532,
    name: 'Wyler Vetta',
    imageUrl: 'https://example.com/wyler-vetta.png',
    description: 'Relojes modernos.',
    isActive: false,
  },
  {
    id: 533,
    name: 'Xemex',
    imageUrl: 'https://example.com/xemex.png',
    description: 'Relojes modernos.',
    isActive: true,
  },
  {
    id: 534,
    name: 'Xetum',
    imageUrl: 'https://example.com/xetum.png',
    description: 'Relojes modernos.',
    isActive: false,
  },
  {
    id: 535,
    name: 'Yantar',
    imageUrl: 'https://example.com/yantar.png',
    description: 'Relojes rusos.',
    isActive: true,
  },
  {
    id: 536,
    name: 'Yema',
    imageUrl: 'https://example.com/yema.png',
    description: 'Relojes franceses.',
    isActive: false,
  },
  {
    id: 537,
    name: 'Yes Watch',
    imageUrl: 'https://example.com/yes-watch.png',
    description: 'Relojes modernos.',
    isActive: true,
  },
  {
    id: 538,
    name: 'Yves Saint Laurent',
    imageUrl: 'https://example.com/yves-saint-laurent.png',
    description: 'Moda y estilo.',
    isActive: false,
  },
  {
    id: 539,
    name: 'Zeitwinkel',
    imageUrl: 'https://example.com/zeitwinkel.png',
    description: 'Relojes alemanes.',
    isActive: true,
  },
  {
    id: 540,
    name: 'Zelos',
    imageUrl: 'https://example.com/zelos.png',
    description: 'Relojes modernos.',
    isActive: false,
  },
  {
    id: 541,
    name: 'Zenith',
    imageUrl: 'brands/zenith.png',
    description: 'Relojes de alta relojería.',
    isActive: true,
  },
  {
    id: 542,
    name: 'Zeno-Watch Basel',
    imageUrl: 'https://example.com/zeno-watch-basel.png',
    description: 'Relojes suizos.',
    isActive: false,
  },
  {
    id: 543,
    name: 'ZentRa',
    imageUrl: 'https://example.com/zentra.png',
    description: 'Relojes modernos.',
    isActive: true,
  },
  {
    id: 544,
    name: 'Zeppelin',
    imageUrl: 'https://example.com/zeppelin.png',
    description: 'Relojes alemanes.',
    isActive: false,
  },
  {
    id: 545,
    name: 'Zodiac',
    imageUrl: 'https://example.com/zodiac.png',
    description: 'Relojes clásicos.',
    isActive: true,
  },
  {
    id: 546,
    name: 'ZRC',
    imageUrl: 'https://example.com/zrc.png',
    description: 'Relojes de buceo.',
    isActive: false,
  },
];
